import { V3Record } from "data/helpers/V3Record.js";

export const STATUS_ACTIVE = 1;
export const STATUS_REMOVED = 5;

export const GoalParticipant = V3Record(
  "goalParticipant",
  {
    amountCompleted: null, // int
    goalId: null, // int
    goalParams: null, // {}
    isAdmin: null, // boolean
    rank: null, // int
    status: null, // int
    trips: null, // int
    userId: null, // int
    userFirstName: null, // string
    userLastName: null, // string
    userName: null, // string
    userEmail: null, // string
    userProfileImg: null, // int
    createdAt: null, // datetime
    updatedAt: null, // datetime
  },
  {
    writable: ["status"],
  }
);
